/* ============================================
   QN-NEW BEST SELLERS JS
   Carrusel de productos con auto-scroll continuo
   (loop por clones), pausa al hover/interaccion.
   ============================================ */

(function () {
  'use strict';

  function initCarousel(carousel) {
    if (!carousel || carousel.dataset.qnbsInit === '1') return;
    var track = carousel.querySelector('[data-track]');
    if (!track) return;
    carousel.dataset.qnbsInit = '1';

    var prevBtn = carousel.querySelector('[data-carousel-prev]');
    var nextBtn = carousel.querySelector('[data-carousel-next]');

    function slideStep() {
      var s = track.querySelector('.qn-best-sellers__slide');
      return s ? s.offsetWidth + 24 : 300;
    }

    // ===== Estado auto-scroll =====
    var autoOn = carousel.dataset.autoscroll === 'true';
    var speed = parseFloat(carousel.dataset.autoscrollSpeed) || 40; // px/seg
    var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var rafId = null;
    var lastTs = 0;
    var paused = false;
    var halfWidth = 0;
    var resumeTimer = null;
    var dragging = false;

    function pauseTemporarily() {
      paused = true;
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function () { paused = false; }, 2000);
    }

    // ===== Flechas =====
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        pauseTemporarily();
        track.scrollBy({ left: -slideStep(), behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        pauseTemporarily();
        track.scrollBy({ left: slideStep(), behavior: 'smooth' });
      });
    }

    // ===== Drag con mouse =====
    var startX, scrollLeft;
    track.addEventListener('mousedown', function (e) {
      dragging = true;
      paused = true;
      track.style.cursor = 'grabbing';
      startX = e.pageX - track.offsetLeft;
      scrollLeft = track.scrollLeft;
    });
    track.addEventListener('mouseleave', function () {
      track.style.cursor = 'grab';
    });
    document.addEventListener('mouseup', function () {
      if (!dragging) return;
      dragging = false;
      track.style.cursor = 'grab';
      pauseTemporarily();
    });
    track.addEventListener('mousemove', function (e) {
      if (!dragging) return;
      e.preventDefault();
      var x = e.pageX - track.offsetLeft;
      track.scrollLeft = scrollLeft - (x - startX) * 2;
    });

    // ===== Pausa al hover / touch / pestania oculta =====
    carousel.addEventListener('mouseenter', function () { paused = true; });
    carousel.addEventListener('mouseleave', function () { if (!dragging) paused = false; });
    track.addEventListener('touchstart', function () { paused = true; }, { passive: true });
    track.addEventListener('touchend', function () { pauseTemporarily(); }, { passive: true });
    document.addEventListener('visibilitychange', function () {
      paused = document.hidden;
      if (!document.hidden) lastTs = 0;
    });

    // ===== Auto-scroll continuo =====
    function setupLoop() {
      if (track.dataset.cloned === '1') return;
      var originals = Array.prototype.slice.call(track.children);
      if (originals.length === 0) return;
      originals.forEach(function (node) {
        var c = node.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        c.dataset.clone = '1';
        track.appendChild(c);
      });
      track.dataset.cloned = '1';
      halfWidth = track.scrollWidth / 2;
    }

    function tick(ts) {
      if (!lastTs) lastTs = ts;
      var dt = (ts - lastTs) / 1000;
      lastTs = ts;
      // dt acotado para que un cambio de pestania no pegue un salto grande
      if (dt > 0.1) dt = 0.1;

      if (!paused && !dragging) {
        track.scrollLeft += speed * dt;
        if (halfWidth > 0 && track.scrollLeft >= halfWidth) {
          track.scrollLeft -= halfWidth;
        }
      }
      rafId = requestAnimationFrame(tick);
    }

    function startAuto() {
      if (!autoOn || prefersReduced || rafId) return;
      // Solo si el contenido original realmente desborda
      if (track.scrollWidth <= track.clientWidth + 4) return;
      track.classList.add('qn-autoscroll'); // desactiva scroll-snap (ver CSS)
      setupLoop();
      lastTs = 0;
      rafId = requestAnimationFrame(tick);
    }

    if (autoOn && !prefersReduced) {
      // pequeno delay para que las medidas (offsetWidth/scrollWidth) esten listas
      setTimeout(startAuto, 350);
      window.addEventListener('load', startAuto);
    }
  }

  function boot() {
    document.querySelectorAll('[data-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var c = e.target && e.target.querySelector && e.target.querySelector('[data-carousel]');
    if (c) initCarousel(c);
  });

  window.QNBestSellers = { init: boot };
})();
